import { useQuery } from 'react-query';
import { DisbursementSharedService } from '../../services/wealthlane-award-settlement-services';

const useGetDisbursementDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
) => {
  const disbursementDetails = useQuery(['getDisbursementDetails', id], async () => {
    if (id) {
      return await handleRequest(
        DisbursementSharedService.getApiAwardSettlementApiAppDisbursementDisbursementDetail(id)
      );
    }
  });
  return disbursementDetails;
};

export default useGetDisbursementDetails;
